// Mock data for T-MINUS Escape Rooms

// Dates on which bookings are not allowed.
// Format: 'YYYY-MM-DD' (ISO).
// Edit this list to add or remove blocked dates.
export const unavailableDates = [
  '2026-04-30',
  '2026-05-04',
  '2026-05-07',
  '2026-05-09',
  '2026-05-10',
  '2026-05-11',
  '2026-05-12',
  '2026-05-13',
  '2026-05-14',
  '2026-05-26',
  '2026-05-29',
];


export const escapeRooms = [
  {
    id: 'cold-war',
    title: 'The Apocalypse of the Cold War',
    titleFr: 'Apocalypse de la Guerre Froide',
    subtitle: 'Finger on the Red Button',
    subtitleFr: 'Le doigt sur le bouton rouge',
    image: 'https://customer-assets.emergentagent.com/job_8f69e04b-00ed-4dd9-b1bd-38052628b8a2/artifacts/h0eaeu69_ChatGPT%20Image%20May%2019%2C%202026%2C%2010_47_27%20AM.png',
    description: 'You are the President of the United States of America, mid–world tour to promote Western ideals, when your aircraft goes down over hostile territory. Across the Iron Curtain, generals assume the unthinkable: assassination. First strike. Nuclear warfare. Governments roll their dice and play their cards... But you\'re not dead. Stranded and officially declared gone, can you prove you\'re alive, restore secure communications, and stop the countdown to global annihilation before silence seals humanity\'s fate?',
    descriptionFr: 'Vous êtes le président des États-Unis, en pleine tournée mondiale pour promouvoir les idéaux occidentaux de liberté et de démocratie, lorsque votre avion s\'écrase en territoire hostile. De l\'autre côté du Rideau de fer, les généraux envisagent l\'impensable: un assassinat, une première frappe, la guerre nucléaire… les dés se roulent et les cartes se jouent. Mais vous n\'êtes pas mort. Bien qu\'échoué et officiellement déclaré disparu, pourrez-vous prouver que vous êtes en vie, rétablir des communications sécurisées et arrêter le compte à rebours de l\'annihilation mondiale?',
    difficulty: 3,
    recordTime: '56 mins 01 sec',
    recordTimeFr: '56 min 01 sec',
    price: 20,
    pricePerPerson: true
  },
  {
    id: 'stranded-in-space',
    title: 'Stranded in Space',
    titleFr: 'Égaré dans l\'Espace',
    subtitle: 'The Apollo 13 Mission',
    subtitleFr: 'La Mission Apollo 13',
    image: 'https://customer-assets.emergentagent.com/job_puzzle-hq/artifacts/fpgoabkt_Patient%20zero.png',
    description: 'You were set to become only the fifth person to ever walk on the moon… until disaster struck 200,000 miles away from Earth. The spacecraft is crippled, oxygen levels begin to plummet, and time is the new enemy. With systems failing and no room for error, every calculation matters, every decision could mean life or death. In the silence of space, one truth becomes clear: failure is not an option. Can you overcome asphyxiation and bring your crew home before time runs out?',
    descriptionFr: 'Vous deviez devenir la cinquième personne à marcher sur la Lune… jusqu\'à ce que la catastrophe ne frappe à 200 000 milles de la Terre, laissant votre vaisseau spatial désemparé. Les niveaux d\'oxygène chutent et que le temps devient le nouvel ennemi. Avec des systèmes défaillants, des plans retracés et aucun droit à l\'erreur, chaque calcul compte, chaque décision peut signifier la vie ou la mort. Dans le silence de l\'espace, une vérité s\'impose: l\'échec n\'est pas une option. Serez-vous aptes à vaincre l\'asphyxie et à ramener votre équipage à la maison avant qu\'il ne soit trop tard?',
    difficulty: 2,
    recordTime: '48 mins 37 sec',
    recordTimeFr: '48 min 37 sec',
    price: 20,
    pricePerPerson: true
  },
  {
    id: 'atlantic-chaos',
    title: 'Chaos on the Atlantic',
    titleFr: 'Chaos sur l\'Atlantique',
    subtitle: 'The Sinking of the Titanic',
    subtitleFr: 'Le Naufrage du Titanic',
    image: 'https://customer-assets.emergentagent.com/job_8f69e04b-00ed-4dd9-b1bd-38052628b8a2/artifacts/uet0hte9_c856d97e-a7db-402a-8b61-75f8587f7eb6.png',
    description: 'We thought it was unsinkable… until the iceberg struck. The hull groans as water floods the lower decks and the ship tilts dangerously with every passing second. Doors slam, debris shifts, and every step could be your last. Trapped in the chaos of the sinking vessel, you must keep your wits and courage to navigate the wreckage. Can you find the hidden escape route and reach the lifeboats before the icy waters of the Atlantic swallow you whole, the hymn of the haunting violin strains playing on indifferently?',
    descriptionFr: 'Nous la pensions insubmersible jusqu\'à ce que l\'iceberg ne frappe: la coque gémit alors que l\'eau inonde les ponts inférieurs et que le navire s\'incline dangereusement à chaque seconde. Les portes claquent, les débris bougent, et chaque pas pourrait être votre dernier. Piégé dans le chaos du bâtiment qui sombre, réussirez-vous à garder votre sang-froid pour naviguer à travers l\'épave afin de trouver la voie d\'évacuation cachée et atteindre les canots de sauvetage avant que les eaux glacées de l\'Atlantique ne vous engloutissent tout entier, l\'hymne des violons fantomatiques qui résonnent, indifférents?',
    difficulty: 4,
    recordTime: '52 mins 32 sec',
    recordTimeFr: '52 min 32 sec',
    price: 20,
    pricePerPerson: true
  },
  {
    id: 'patient-zero',
    title: 'Patient Zero',
    titleFr: 'Patient Zéro',
    subtitle: 'The Covid-19 Pandemic',
    subtitleFr: 'La Pandémie de Covid-19',
    image: 'https://customer-assets.emergentagent.com/job_8f69e04b-00ed-4dd9-b1bd-38052628b8a2/artifacts/44zgsnz8_ChatGPT%20Image%20May%2019%2C%202026%2C%2010_24_51%20AM.png',
    description: 'It\'s 2020 again... The world watches an unfamiliar virus emerge… you are now fighting an invisible enemy while cities shut down and life grinds to a halt. Supplies are scarce, fear is spreading faster than infection, and without proper protection, every interaction could be fatal. If you can\'t set up an international cooperation to supply PPE needed to flatten the curve, there may be no return to normalcy. Can you find the masks in time and prevent humanity from suffocating under its own silence?',
    descriptionFr: 'Nous retournons en 2020... Le monde regarde émerger un virus inconnu… vous vous retrouvez ainsi à combattre un ennemi invisible tandis que des villes entrent en quarantaine et que la vie s\'arrête. L\'équipement médicale se fait rare et la peur se propage plus vite que l\'infection. Sans protection adéquate, chaque interaction pourrait être fatale. Si vous ne parvenez pas à instaurer une coopération internationale pour fournir les EPI nécessaires afin d\'aplatir la courbe, il n\'y aura peut-être pas de retour à la normale… Saurez-vous localiser les masques à temps pour empêcher l\'humanité de s\'étouffer sous son silence?',
    difficulty: 2.5,
    recordTime: '49 mins 42 sec',
    recordTimeFr: '49 min 42 sec',
    price: 20,
    pricePerPerson: true
  },
  {
    id: 'operation-overload',
    title: 'Operation Overload',
    titleFr: 'Opération Overload',
    subtitle: 'The D-Day Invasion',
    subtitleFr: 'L\'Invasion du Jour-J',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_8f69e04b-00ed-4dd9-b1bd-38052628b8a2/artifacts/jguzk46y_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2002_06_40%20PM.png',
    description: 'Parachuted behind enemy lines on D-Day, you join the French Resistance in a hidden bunker, ready to carry a perilous mission to weaken the opponent. German artillery threaten the success of the Allied invasion, and it\'s up to you to locate their positions. But there\'s a catch: communication lines are compromised, and the clock is ticking. Can you transmit the coordinates before the beaches turn into a bloodbath, the invasion falters and history is rewritten?',
    descriptionFr: 'Parachuté derrière les lignes ennemies le Jour-J, vous rejoignez la Résistance française dans un bunker caché, prêt à mener une mission périlleuse pour affaiblir l\'adversaire. Alors que l\'artillerie allemande menace le succès de l\'invasion alliée, c\'est à vous de localiser ses positions afin que l\'armée de l\'air puisse les mettre hors service. Mais il y a un hic: les lignes de communication sont compromises et le temps presse. Parviendrez-vous à transmettre les coordonnées avant que les plages ne se transforment en bain de sang, que l\'invasion n\'échoue et que l\'histoire ne soit réécrite?',
    difficulty: 1,
    recordTime: '43 mins 11 sec',
    recordTimeFr: '43 min 11 sec',
    price: 20,
    pricePerPerson: true
  },
  {
    id: 'vini-vidi-vici',
    title: 'Rome 2048',
    titleFr: 'Rome 2048',
    subtitle: 'Vini, Vidi, Vici',
    subtitleFr: 'Vini, Vidi, Vici',
    image: 'https://customer-assets.emergentagent.com/job_8f69e04b-00ed-4dd9-b1bd-38052628b8a2/artifacts/pfnjiiqz_ChatGPT%20Image%20May%2018%2C%202026%2C%2005_58_05%20PM.png',
    description: 'The world gathers beneath the banners of a reborn empire, where glory is eternal, and victory is worshipped above all else. You arrive in the Colosseum as an elite runner, carrying your nation\'s pride on your shoulders, with a chance to etch your name in history. But as you cross the finish line just short of the podium, whispers of corruption echo behind the spectacle of the Games. As the closing ceremony approaches and tensions rise, can you uncover the crime and crown the righteous victor?',
    descriptionFr: 'Le monde se rassemble sous les bannières d\'un empire renaissant, où la gloire est éternelle et la victoire vénérée par-dessus tout. Vous arrivez au Colisée en tant que coureur d\'élite, portant la fierté de votre nation sur vos épaules, avec la chance de graver votre nom dans l\'histoire. Mais alors que vous franchissez la ligne d\'arrivée juste au pied du podium, des rumeurs de corruption résonnent derrière le spectacle des Jeux. Tandis que la cérémonie de clôture approche et que les tensions montent, parviendrez-vous à démasquer le crime et à couronner le juste vainqueur?',
    difficulty: 5,
    recordTime: '45 mins 15 sec',
    recordTimeFr: '45 min 15 sec',
    price: 20,
    pricePerPerson: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    nameFr: 'Sarah Mitchell',
    date: 'November 15, 2024',
    dateFr: '15 novembre 2024',
    rating: 5,
    text: 'Absolutely incredible experience! We did the Titanic room for my birthday and it was so immersive. The mobile setup was seamless, and the historical detail was outstanding. Can\'t wait to try another room!',
    textFr: 'Expérience absolument incroyable ! Nous avons fait la salle du Titanic pour mon anniversaire et c\'était tellement immersif. L\'installation mobile était sans faille, et le souci du détail historique était exceptionnel. J\'ai hâte d\'essayer une autre salle !'
  },
  {
    id: 2,
    name: 'Marcus Johnson',
    nameFr: 'Marcus Johnson',
    date: 'October 22, 2024',
    dateFr: '22 octobre 2024',
    rating: 5,
    text: 'T-MINUS brought the D-Day room to our office for team building. Everyone was engaged and working together. The puzzles were challenging but fair. Highly recommend for corporate events!',
    textFr: 'T-MINUS a apporté la salle du Jour-J à notre bureau pour une activité de team building. Tout le monde était engagé et travaillait ensemble. Les énigmes étaient difficiles mais équitables. Je recommande vivement pour les événements d\'entreprise !'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    nameFr: 'Emily Rodriguez',
    date: 'September 8, 2024',
    dateFr: '8 septembre 2024',
    rating: 5,
    text: 'The Apollo 13 escape room was mind-blowing! As a history teacher, I appreciated how accurate and educational it was while still being thrilling. My students loved it for our class event.',
    textFr: 'La salle d\'évasion Apollo 13 était époustouflante ! En tant qu\'enseignante d\'histoire, j\'ai apprécié à quel point elle était précise et éducative tout en étant palpitante. Mes élèves l\'ont adorée pour notre événement de classe.'
  },
  {
    id: 4,
    name: 'David Chen',
    nameFr: 'David Chen',
    date: 'August 30, 2024',
    dateFr: '30 août 2024',
    rating: 5,
    text: 'What a unique concept! Being able to have the escape room come to us was so convenient. We did the Chernobyl room in our basement and it was intense. Great attention to atmosphere and storytelling.',
    textFr: 'Quel concept unique ! Pouvoir faire venir la salle d\'évasion chez nous était tellement pratique. Nous avons fait la salle de Tchernobyl dans notre sous-sol et c\'était intense. Belle attention à l\'atmosphère et à la narration.'
  },
  {
    id: 5,
    name: 'Jennifer Park',
    nameFr: 'Jennifer Park',
    date: 'July 18, 2024',
    dateFr: '18 juillet 2024',
    rating: 5,
    text: 'Best escape room experience I\'ve ever had! The Vesuvius room was perfectly balanced - challenging enough to be exciting but not frustrating. The historical theme made it extra special. Five stars!',
    textFr: 'Meilleure expérience de salle d\'évasion que j\'ai jamais eue ! La salle du Vésuve était parfaitement équilibrée - assez difficile pour être excitante mais pas frustrante. Le thème historique l\'a rendue encore plus spéciale. Cinq étoiles !'
  }
];

export const translations = {
  en: {
    nav: {
      home: 'Home',
      rooms: 'Our Rooms',
      howItWorks: 'How It Works',
      prizes: 'Prizes',
      testimonials: 'Testimonials',
      about: 'About & Contact'
    },
    hero: {
      motto: 'Turning any room into an escape experience'
    },
    rooms: {
      title: 'Our Escape Rooms',
      subtitle: 'Pick your location. Pick your date. And we take care of the rest.',
      difficulty: 'Difficulty',
      record: 'Record Breakout',
      learnMore: 'Learn More',
      price: 'per person',
      howItWorks: {
        title: 'How It Works',
        content: `Step into the adventure… wherever you are.\n\nWe bring the escape room experience to you, fully loaded with all the props, puzzles, and challenge you need for an unforgettable hour. Whether it's your office, classroom, basement, or even the park, our mobile setup transforms any space into a thrilling escape experience.\n\nOur tried-and-tested themes are designed for fast setup and teardown and players of all skill levels and ages. Each game lasts 1 hour - perfect for parties, team building, school events, or family fun.\n\nWe handle everything so all you have to worry about is cracking the codes, solving the mysteries, and beating the clock.`
      },
      prizes: {
        title: 'Rewards & Prizes',
        breakout: '10% Off Your Next Escape',
        breakoutDesc: 'Successfully break out and earn a discount on your next adventure',
        record: '20% Off for Record Breakers',
        recordDesc: 'Set a new record time and double your savings!'
      },
      bulkEvent: {
        title: 'Planning a Larger Event?',
        subtitle: 'Book multiple rooms for an unforgettable group experience',
        buttonText: 'Get a Custom Quote'
      }
    },
    testimonials: {
      title: 'What Our Players Say'
    },
    about: {
      title: 'About T-MINUS',
      mission: 'Our Mission',
      missionText: 'At T-MINUS, we\'re dedicated to bringing immersive, accessible, and thrilling adventures directly to you, wherever you are. Created in 2024, we\'ve hosted office and school events, private parties, fundraisers, and many more. Through innovative, high-quality puzzles and storytelling, we aim to spark curiosity, teamwork, and unforgettable memories for players of all ages and skill levels.',
      contact: 'Contact Us',
      inquiry: 'Have an inquiry? Contact us!',
      email: 'inquiry@t-minus-escape.com'
    },
    booking: {
      title: 'Submit a Booking',
      subtitle: 'Ready to book your adventure? Fill out the form below.',
      email: 'Email Address',
      eventType: 'Type of Event',
      privateParty: 'Private Party',
      schoolEvent: 'School Event',
      officeEvent: 'Office Event',
      players: 'Number of Players',
      location: 'Location of Setup',
      date: 'Date of Event',
      time: 'Time of Event',
      paymentMethod: 'Payment Method',
      card: 'Card',
      cash: 'Cash',
      etransfer: 'E-Transfer',
      cheque: 'Cheque',
      totalPrice: 'Total Price',
      refundPolicy: 'Fully refundable up to 24 hours before event',
      submit: 'Next',
      success: 'Thank you! Your booking has been submitted. We\'ll contact you soon to confirm.',
      error: 'Please fill out all fields.'
    },
    quote: {
      title: 'Get a Quote',
      subtitle: 'Ready to book your adventure? Fill out the form below and we\'ll get back to you shortly.',
      email: 'Email Address',
      eventType: 'Type of Event',
      privateParty: 'Private Party',
      schoolEvent: 'School Event',
      officeEvent: 'Office Event',
      players: 'Number of Players',
      location: 'Location of Setup',
      date: 'Date of Event',
      time: 'Time of Event',
      submit: 'Submit Request',
      success: 'Thank you! We\'ll contact you soon with a custom quote.',
      error: 'Please fill out all fields.'
    },
    footer: {
      rights: 'All rights reserved.',
      tagline: 'Bringing history to life, one escape at a time.'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      rooms: 'Nos Salles',
      howItWorks: 'Comment Ça Fonctionne',
      prizes: 'Prix',
      testimonials: 'Témoignages',
      about: 'À Propos & Contact'
    },
    hero: {
      motto: 'Transformer n\'importe quelle pièce en une expérience d\'évasion'
    },
    rooms: {
      title: 'Nos Salles d\'Évasion',
      subtitle: 'Choisissez votre lieu. Choisissez votre date. Et nous nous occupons du reste.',
      difficulty: 'Difficulté',
      record: 'Record d\'Évasion',
      learnMore: 'En Savoir Plus',
      price: 'par personne',
      howItWorks: {
        title: 'Comment Ça Fonctionne',
        content: `Entrez dans l\'aventure… où que vous soyez.\n\nNous apportons l\'expérience de la salle d\'évasion chez vous, entièrement équipée avec tous les accessoires, énigmes et défis dont vous avez besoin pour une heure inoubliable. Que ce soit dans votre bureau, votre salle de classe, votre sous-sol ou même au parc, notre installation mobile transforme n\'importe quel espace en une expérience d\'évasion palpitante.\n\nNos thèmes éprouvés sont conçus pour une installation et un démontage rapides et des joueurs de tous niveaux et âges. Chaque jeu dure 1 heure - parfait pour les fêtes, le team building, les événements scolaires ou les loisirs en famille.\n\nNous nous occupons de tout, vous n\'avez qu\'à vous soucier de craquer les codes, résoudre les mystères et battre le chronomètre.`
      },
      prizes: {
        title: 'Récompenses et Prix',
        breakout: '10% de Réduction sur Votre Prochaine Évasion',
        breakoutDesc: 'Réussissez votre évasion et obtenez une réduction sur votre prochaine aventure',
        record: '20% de Réduction pour les Records',
        recordDesc: 'Établissez un nouveau temps record et doublez vos économies !'
      },
      bulkEvent: {
        title: 'Planification d\'un Événement Plus Grand?',
        subtitle: 'Réservez plusieurs salles pour une expérience de groupe inoubliable',
        buttonText: 'Obtenir un Devis Personnalisé'
      }
    },
    testimonials: {
      title: 'Ce Que Disent Nos Joueurs'
    },
    about: {
      title: 'À Propos de T-MINUS',
      mission: 'Notre Mission',
      missionText: 'Chez T-MINUS, nous nous consacrons à offrir des aventures immersives, accessibles et palpitantes directement chez vous, où que vous soyez. Créée en 2024, nous organisons des événements d\'entreprise, des fêtes privées, des activités scolaires, des collectes de fonds, et bien plus encore. Grâce à des énigmes et des récits innovants et de haute qualité, nous cherchons à éveiller la curiosité, favoriser le travail d\'équipe et créer des souvenirs inoubliables pour les joueurs de tous âges et de tous niveaux.',
      contact: 'Contactez-nous',
      inquiry: 'Vous avez une question ? Contactez-nous !',
      email: 'renseignements@t-minus-escape.com'
    },
    booking: {
      title: 'Soumettre une Réservation',
      subtitle: 'Prêt à réserver votre aventure ? Remplissez le formulaire ci-dessous.',
      email: 'Adresse E-mail',
      eventType: 'Type d\'Événement',
      privateParty: 'Fête Privée',
      schoolEvent: 'Événement Scolaire',
      officeEvent: 'Événement Bureau',
      players: 'Nombre de Joueurs',
      location: 'Lieu d\'Installation',
      date: 'Date de l\'Événement',
      time: 'Heure de l\'Événement',
      paymentMethod: 'Méthode de Paiement',
      card: 'Carte',
      cash: 'Comptant',
      etransfer: 'Virement Électronique',
      cheque: 'Chèque',
      totalPrice: 'Prix Total',
      refundPolicy: 'Entièrement remboursable jusqu\'à 24 heures avant l\'événement',
      submit: 'Suivant',
      success: 'Merci ! Votre réservation a été soumise. Nous vous contacterons bientôt pour confirmer.',
      error: 'Veuillez remplir tous les champs.'
    },
    quote: {
      title: 'Obtenir un Devis',
      subtitle: 'Prêt à réserver votre aventure ? Remplissez le formulaire ci-dessous et nous vous répondrons sous peu.',
      email: 'Adresse E-mail',
      eventType: 'Type d\'Événement',
      privateParty: 'Fête Privée',
      schoolEvent: 'Événement Scolaire',
      officeEvent: 'Événement Bureau',
      players: 'Nombre de Joueurs',
      location: 'Lieu d\'Installation',
      date: 'Date de l\'Événement',
      time: 'Heure de l\'Événement',
      submit: 'Envoyer la Demande',
      success: 'Merci ! Nous vous contacterons bientôt avec un devis personnalisé.',
      error: 'Veuillez remplir tous les champs.'
    },
    footer: {
      rights: 'Tous droits réservés.',
      tagline: 'Donner vie à l\'histoire, une évasion à la fois.'
    }
  }
};